// extracted by mini-css-extract-plugin
module.exports = {"toAutos":"SpecialCarsComponent-module__toAutos","services_postsContainer":"SpecialCarsComponent-module__services_postsContainer"};